import * as Slot from '@/ui/primitives/slot'
import type { TextRef } from '@/ui/primitives/types'
import { cn } from '@/ui/utils'
import { forwardRef } from 'react'
import { Text as RNText } from 'react-native'
import { headerStyles } from './header.styles'
import type { HeaderProps } from './header.types'

const Header = forwardRef<TextRef, HeaderProps>(
	({ className, asChild = false, variant = 'h1', ...props }, ref) => {
		const Component = asChild ? Slot.Text : RNText

		return (
			<Component
				role="heading"
				className={cn(headerStyles({ variant }), className)}
				ref={ref}
				{...props}
			/>
		)
	}
)

Header.displayName = 'Header'

export { Header }
